import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    products: [], //Array of all lists
}

export const productionLineSlice = createSlice({
    name: 'productionLine',
    initialState,
    reducers: {
        setProductsList: (state, { payload }) => {
            let { products } = payload;
            // State
            state.products = products
        },

    },
})

// Action creators are generated for each case reducer function
export const { setProductsList} = productionLineSlice.actions
export default productionLineSlice.reducer
